module.exports = __webpack_public_path__ + "f924fe9250f9fc712793ed8a50ae2435.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/pin_24.svg
// module id = 1366
// module chunks = 73